<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <h2 class="text-[20px] font-semibold font-inter text-gray-900 m-0">Pagar Fatura</h2>
        <button class="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-lg transition-all duration-200"
                (click)="closeModal()">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 p-6 overflow-y-auto">
        <!-- Seção: Valores -->
        <div class="w-full py-4">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon class="icon-size-6 text-blue-600" [svgIcon]="'mat_solid:attach_money'"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Valores</span>
                    </div>
                </div>
            </div>
            <div class="w-full p-4">
                <!-- Cards de valores -->
                <div class="grid grid-cols-2 it:grid-cols-4 gap-3">
                    <div class="bg-gray-100 rounded-xl p-4 text-center">
                        <span class="font-inter font-[400] text-[11px] text-gray-500 uppercase block mb-1">Valor Total</span>
                        <span class="font-remote font-[700] text-[18px] text-gray-800">
                            {{ formatCurrency(data.invoice.amount) }}
                        </span>
                    </div>
                    <div class="rounded-xl p-4 text-center"
                         [ngClass]="{
                            'bg-yellow-50': data.invoice.status === 'pending',
                            'bg-green-50': data.invoice.status === 'paid',
                            'bg-red-50': data.invoice.status === 'failed',
                            'bg-gray-50': data.invoice.status === 'void'
                         }">
                        <span class="font-inter font-[400] text-[11px] uppercase block mb-1"
                              [ngClass]="{
                                'text-yellow-600': data.invoice.status === 'pending',
                                'text-green-600': data.invoice.status === 'paid',
                                'text-red-600': data.invoice.status === 'failed',
                                'text-gray-600': data.invoice.status === 'void'
                              }">Status</span>
                        <span class="font-remote font-[700] text-[18px]"
                              [ngClass]="{
                                'text-yellow-700': data.invoice.status === 'pending',
                                'text-green-700': data.invoice.status === 'paid',
                                'text-red-700': data.invoice.status === 'failed',
                                'text-gray-700': data.invoice.status === 'void'
                              }">
                            {{ getStatusLabel(data.invoice.status) }}
                        </span>
                    </div>
                    <div class="bg-orange-50 rounded-xl p-4 text-center">
                        <span class="font-inter font-[400] text-[11px] text-orange-600 uppercase block mb-1">Vencimento</span>
                        <span class="font-remote font-[700] text-[18px] text-orange-700">
                            {{ data.invoice.due_date }}
                        </span>
                    </div>
                    <div class="rounded-xl p-4 text-center"
                         [ngClass]="data.invoice.status === 'paid' ? 'bg-blue-50' : 'bg-gray-100'">
                        <span class="font-inter font-[400] text-[11px] uppercase block mb-1"
                              [ngClass]="data.invoice.status === 'paid' ? 'text-blue-600' : 'text-gray-500'">Pagamento</span>
                        <span class="font-remote font-[700] text-[18px]"
                              [ngClass]="data.invoice.status === 'paid' ? 'text-blue-700' : 'text-gray-800'">
                            {{ data.invoice.paid_at || '-' }}
                        </span>
                    </div>
                </div>

                <!-- Barra de progresso -->
                <div class="mt-4">
                    <div class="flex items-center justify-between mb-2">
                        <span class="font-inter font-[400] text-[12px] text-gray-500">Status do pagamento</span>
                        <span class="font-inter font-[600] text-[12px]"
                              [ngClass]="{
                                'text-yellow-600': data.invoice.status === 'pending',
                                'text-green-600': data.invoice.status === 'paid',
                                'text-red-600': data.invoice.status === 'failed',
                                'text-gray-600': data.invoice.status === 'void'
                              }">
                            {{ getPaymentProgress() }}%
                        </span>
                    </div>
                    <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div class="h-full transition-all duration-500"
                             [ngClass]="{
                                'bg-yellow-500': data.invoice.status === 'pending',
                                'bg-green-500': data.invoice.status === 'paid',
                                'bg-red-500': data.invoice.status === 'failed',
                                'bg-gray-400': data.invoice.status === 'void'
                             }"
                             [class.rounded-full]="getPaymentProgress() === 0 || getPaymentProgress() === 100"
                             [style.width.%]="getPaymentProgress()"></div>
                    </div>
                    <div class="flex items-center justify-between mt-1">
                        <span class="font-inter font-[400] text-[11px] text-gray-500">
                            Fatura {{ data.invoice.number }}
                        </span>
                        <span *ngIf="data.invoice.status === 'pending'" class="font-inter font-[400] text-[11px] text-yellow-600">
                            Aguardando pagamento
                        </span>
                        <span *ngIf="data.invoice.status === 'paid'" class="font-inter font-[500] text-[11px] text-green-600">
                            ✓ Pagamento realizado
                        </span>
                        <span *ngIf="data.invoice.status === 'failed'" class="font-inter font-[400] text-[11px] text-red-600">
                            Pagamento falhou
                        </span>
                        <span *ngIf="data.invoice.status === 'void'" class="font-inter font-[400] text-[11px] text-gray-400">
                            Fatura cancelada
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Seleção de Método (quando não há pagamento gerado) -->
        <ng-container *ngIf="!paymentData">
            <p class="text-[14px] font-inter font-[400] text-gray-600 mb-4">
                Selecione a forma de pagamento:
            </p>

            <div class="space-y-3">
                <!-- Boleto -->
                <div class="p-4 border rounded-xl cursor-pointer transition-all"
                     [ngClass]="selectedMethod === 'boleto' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'"
                     (click)="selectMethod('boleto')">
                    <div class="flex items-center gap-3">
                        <div class="p-2 rounded-lg" [ngClass]="selectedMethod === 'boleto' ? 'bg-blue-100' : 'bg-yellow-50'">
                            <mat-icon class="icon-size-6"
                                      [ngClass]="selectedMethod === 'boleto' ? 'text-blue-600' : 'text-yellow-600'"
                                      [svgIcon]="'mat_solid:receipt'"></mat-icon>
                        </div>
                        <div class="flex-1">
                            <span class="text-[15px] font-inter font-[500] text-gray-900 block">Boleto Bancário</span>
                            <span class="text-[13px] font-inter font-[400] text-gray-500">Vencimento em 3 dias úteis</span>
                        </div>
                        <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
                             [ngClass]="selectedMethod === 'boleto' ? 'border-blue-500' : 'border-gray-300'">
                            <div class="w-3 h-3 rounded-full bg-blue-500" *ngIf="selectedMethod === 'boleto'"></div>
                        </div>
                    </div>
                </div>

                <!-- PIX -->
                <div class="p-4 border rounded-xl cursor-pointer transition-all"
                     [ngClass]="selectedMethod === 'pix' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'"
                     (click)="selectMethod('pix')">
                    <div class="flex items-center gap-3">
                        <div class="p-2 rounded-lg" [ngClass]="selectedMethod === 'pix' ? 'bg-blue-100' : 'bg-green-50'">
                            <mat-icon class="icon-size-6"
                                      [ngClass]="selectedMethod === 'pix' ? 'text-blue-600' : 'text-green-600'"
                                      [svgIcon]="'mat_solid:qr_code'"></mat-icon>
                        </div>
                        <div class="flex-1">
                            <span class="text-[15px] font-inter font-[500] text-gray-900 block">PIX</span>
                            <span class="text-[13px] font-inter font-[400] text-gray-500">Pagamento instantâneo</span>
                        </div>
                        <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
                             [ngClass]="selectedMethod === 'pix' ? 'border-blue-500' : 'border-gray-300'">
                            <div class="w-3 h-3 rounded-full bg-blue-500" *ngIf="selectedMethod === 'pix'"></div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Dados do Boleto Gerado -->
        <ng-container *ngIf="paymentData?.boleto">
            <div class="text-center">
                <div class="p-3 bg-green-50 rounded-lg inline-flex items-center gap-2 mb-4">
                    <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'mat_solid:check_circle'"></mat-icon>
                    <span class="text-[14px] font-inter font-[500] text-green-700">Boleto gerado com sucesso!</span>
                </div>

                <p class="text-[13px] font-inter font-[400] text-gray-500 mb-4">
                    Vencimento: {{ paymentData.boleto.expires_at }}
                </p>

                <!-- Código de barras -->
                <div class="p-4 bg-gray-50 rounded-xl mb-4">
                    <p class="text-[12px] font-inter font-[500] text-gray-500 mb-2">Código de barras:</p>
                    <p class="text-[14px] font-mono font-[500] text-gray-900 break-all">
                        {{ paymentData.boleto.barcode }}
                    </p>
                </div>

                <div class="flex gap-3 justify-center">
                    <button class="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                            (click)="copyToClipboard(paymentData.boleto.barcode)">
                        <mat-icon class="icon-size-4 text-gray-600" [svgIcon]="'mat_outline:content_copy'"></mat-icon>
                        <span class="text-[14px] font-inter font-[500] text-gray-700">Copiar código</span>
                    </button>
                    <a [href]="paymentData.boleto.pdf_url" target="_blank"
                       class="flex items-center gap-2 px-4 py-2 bg-[#0061ff] hover:bg-[#2f75e7] rounded-lg transition-colors">
                        <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:download'"></mat-icon>
                        <span class="text-[14px] font-inter font-[500] text-white">Baixar PDF</span>
                    </a>
                </div>
            </div>
        </ng-container>

        <!-- Dados do PIX Gerado -->
        <ng-container *ngIf="paymentData?.pix">
            <div class="text-center">
                <div class="p-3 bg-green-50 rounded-lg inline-flex items-center gap-2 mb-4">
                    <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'mat_solid:check_circle'"></mat-icon>
                    <span class="text-[14px] font-inter font-[500] text-green-700">PIX gerado com sucesso!</span>
                </div>

                <p class="text-[13px] font-inter font-[400] text-gray-500 mb-4">
                    Expira em: {{ paymentData.pix.expires_at }}
                </p>

                <!-- QR Code -->
                <div class="flex justify-center mb-4">
                    <img [src]="paymentData.pix.qr_code_url"
                         alt="QR Code PIX"
                         class="w-48 h-48 border border-gray-200 rounded-xl">
                </div>

                <!-- Código PIX -->
                <div class="p-4 bg-gray-50 rounded-xl mb-4">
                    <p class="text-[12px] font-inter font-[500] text-gray-500 mb-2">Código PIX (copia e cola):</p>
                    <p class="text-[12px] font-mono font-[500] text-gray-900 break-all max-h-20 overflow-y-auto">
                        {{ paymentData.pix.qr_code }}
                    </p>
                </div>

                <button class="flex items-center gap-2 px-4 py-2 bg-[#0061ff] hover:bg-[#2f75e7] rounded-lg transition-colors mx-auto"
                        (click)="copyToClipboard(paymentData.pix.qr_code)">
                    <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_outline:content_copy'"></mat-icon>
                    <span class="text-[14px] font-inter font-[500] text-white">Copiar código PIX</span>
                </button>
            </div>
        </ng-container>
    </div>

    <!-- Footer (quando não há pagamento gerado) -->
    <div class="p-6 border-t border-gray-200" *ngIf="!paymentData">
        <div class="flex justify-end gap-3">
            <button class="px-6 py-2 rounded-3xl bg-gray-200 hover:bg-gray-300 transition-colors"
                    (click)="closeModal()"
                    [disabled]="loading">
                <span class="font-inter font-[500] text-[15px] text-gray-800">Cancelar</span>
            </button>
            <button class="px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-w-[140px]"
                    [disabled]="!selectedMethod || loading"
                    (click)="processPayment()">
                <span class="font-inter font-[500] text-[15px] text-white" *ngIf="!loading">Gerar Pagamento</span>
                <mat-progress-spinner *ngIf="loading" [diameter]="18" [mode]="'indeterminate'" class="m-auto spinner-white"></mat-progress-spinner>
            </button>
        </div>
    </div>

    <!-- Footer (quando há pagamento gerado) -->
    <div class="p-6 border-t border-gray-200" *ngIf="paymentData">
        <div class="flex justify-center">
            <button class="px-6 py-2 rounded-3xl bg-gray-200 hover:bg-gray-300 transition-colors"
                    (click)="closeModal()">
                <span class="font-inter font-[500] text-[15px] text-gray-800">Fechar</span>
            </button>
        </div>
    </div>
</div>
